import { toJSON as cssToJSON } from 'css-convert-json';
import { MSONumberFormat, NumberFormat } from '../models/datasheet';

export function extractNumberFormatFromExcelHtml(data: string): NumberFormat | undefined {
  try {
    const cssStyles = cssToJSON(data);

    const cssNumberFormat: MSONumberFormat = cssStyles.children[Object.keys(cssStyles.children)[0]]
      .attributes as unknown as MSONumberFormat;

    function sanitizeString<T>(text: string) {
      return text.replace(/(^"\\)|(^")|("$)/g, '') as unknown as T;
    }

    const numberFormat: NumberFormat = {
      decimalSeparator: sanitizeString(cssNumberFormat['mso-displayed-decimal-separator']),
      thousandSeparator: sanitizeString(cssNumberFormat['mso-displayed-thousand-separator']),
    };

    return numberFormat;
  } catch (error) {
    return undefined;
  }
}
